import React, { useState, useEffect, lazy, Suspense } from 'react';
import './App.css';
import { useSelector, useDispatch } from 'react-redux';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
// -------- APP CONTAINER DRAWER REQUIRE
// import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
// import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
// -------- APP CONTAINER DRAWER REQUIRE END

// -------- APP COMPONENT REQUIRE
import APP_FEATURES from './features.config';
import { LOGOUT_TYPE } from './redux/action/type.action';
import { LoginComponent } from './components/login/login.component';
import { checkIdentity } from './redux/reducers/identity.reducer';
import ProtectedRoute from './components/_shared/component/protectedRoute/protectedRoute.component';

import BreadcrumbsComponent from './components/breadcrumb/breadcrumb.component';
import DrawerListComponent from './components/drawerList/drawerList.component';
import LoaderBackDrop from './components/_shared/component/loaderBackDrop/loaderBackDrop.component';
import SnackBarComponent from './components/_shared/component/snackbar/snackbar.component';
import ComfirmationComponent from './components/_shared/component/confirmation/confirmation.component';
import MrssSeriesFormComponent from './components/mrss/mrssSeriesForm.component';
// -------- APP COMPONENT REQUIRE END

//TODO array.map do RETURN

// react lazy loading component
const DashboardComponent = lazy(() => import('./components/dashboard/dashboard.component'));
const SubDashboardComponent = lazy(() => import('./components/dashboard/subDashboard.component'));
const UserComponent = lazy(() => import('./components/user/user.component'));
const UserAddComponent = lazy(() => import('./components/user/userAdd.component'));
const UserInfoComponent = lazy(() => import('./components/user/userInfo.component'));
const AccessControlComponent = lazy(
  () => import('./components/accessControl/accessControlList.component')
);
const AccessControlUserFormComponent = lazy(
  () => import('./components/accessControl/accessControlUserForm.component')
);
const AccessControlGroupFormComponent = lazy(
  () => import('./components/accessControl/accessControlGroupForm.component')
);
const AccessControlPermissionFormComponent = lazy(
  () => import('./components/accessControl/accessControlPermissionForm.component')
);
const AirVuzMrssReportComponent = lazy(
  () => import('./components/reports/airVuzMrssLibaryReport/airVuzMrssLibaryReport.component')
);
const AirVuzMrssReportResultComponent = lazy(
  () => import('./components/reports/airVuzMrssLibaryReport/airvuzMrssLibaryReportResult.component')
);
const VideoComponent = lazy(() => import('./components/video/videoList.component'));
const UploadComponent = lazy(() => import('./components/upload/uploadList.component'));
const VideoCurationComponent = lazy(() => import('./components/video/videoCuration.component'));
const CollectionComponent = lazy(() => import('./components/collection/collectionList.component'));
const CollectionFormComponent = lazy(
  () => import('./components/collection/collectionForm.component')
);
const CollectionFormCopyComponent = lazy(
  () => import('./components/collection/collectionFormCopy.component')
);
const CollectionPhotoComponent = lazy(
  () => import('./components/collectionPhoto/collectionPhotoList.component')
);
const CollectionPhotoAddFormComponent = lazy(
  () => import('./components/collectionPhoto/collectionPhotoAddForm.component')
);
const CollectionPhotoEditFormComponent = lazy(
  () => import('./components/collectionPhoto/collectionPhotoEditForm.component')
);
const CommentComponent = lazy(() => import('./components/comment/comment.component'));
const ReportVideoDeleteComponent = lazy(() => import('./components/reports/videoDelete.component'));
const ReportVideoFeatureComponent = lazy(
  () => import('./components/reports/videoFeature.component')
);
const ReportJudgeCollectionComponent = lazy(
  () => import('./components/reports/judge/judgeCollection.component')
);
const ReportJudgeResultComponent = lazy(
  () => import('./components/reports/judge/judgeResult.component')
);
const ReportJudgeResultOneComponent = lazy(
  () => import('./components/reports/judge/judgeResultOne.component')
);
const ReportJudgeResultArchive = lazy(
  () => import('./components/reports/judge/judgeArchiveResult.component')
);
const ReportJudgeArchiveInfo = lazy(
  () => import('./components/reports/judge/judgeArchiveInfo.component')
);
const BadgeListComponent = lazy(() => import('./components/badge/badgeList.component'));
const BadgeFormComponent = lazy(() => import('./components/badge/badgeForm.component'));
const CategoryListComponent = lazy(() => import('./components/category/categoryList.component'));
const CategoryComponent = lazy(() => import('./components/category/categoryForm.component'));
const CollectionTypeListComponent = lazy(
  () => import('./components/collectionType/collectionTypeList.component')
);
const CollectionTypeFormComponent = lazy(
  () => import('./components/collectionType/collectionTypeForm.component')
);
const HistoryComponent = lazy(() => import('./components/history/history.component'));
const ContestTypeFormComponent = lazy(
  () => import('./components/contest/contestTypeForm.component')
);
const ContestFormComponent = lazy(() => import('./components/contest/contestForm.component'));
const BannerSliderFormComponent = lazy(
  () => import('./components/banner/bannerSliderForm.component')
);
const BannerFormComponent = lazy(() => import('./components/banner/bannerForm.component'));
const PartnerComponent = lazy(() => import('./components/partner/partnerForm.component'));
const PartnerExclusiveListComponent = lazy(
  () => import('./components/partner/exclusive/partnerExclusiveList.component')
);
const PartnerExclusiveAddComponent = lazy(
  () => import('./components/partner/exclusive/partnerExclusiveAdd.component')
);
const PartnerExclusiveEditComponent = lazy(
  () => import('./components/partner/exclusive/partnerExclusiveEdit.component')
);
const PartnerListComponent = lazy(() => import('./components/partner/partnerList.component'));
const ContestComponent = lazy(() => import('./components/contest/contestList.component'));
const BannerComponent = lazy(() => import('./components/banner/bannerList.component'));
const AutoViewEditFormComponent = lazy(
  () => import('./components/autoView/autoViewEditForm.component')
);
const AutoViewAddFormComponent = lazy(
  () => import('./components/autoView/autoViewAddForm.component')
);
const AutoViewListComponent = lazy(() => import('./components/autoView/autoViewList.component'));
const FeatureBoxListComponent = lazy(
  () => import('./components/featureBox/featureBoxList.component')
);
const FeatureBoxLocationForm = lazy(
  () => import('./components/featureBox/featureBoxLocationForm.component')
);
const FeatureBoxFormComponent = lazy(
  () => import('./components/featureBox/featureBoxForm.component')
);
const PhotoListComponent = lazy(() => import('./components/photo/photoList.component'));
const PhotoCurationComponent = lazy(() => import('./components/photo/photoCuration.component'));
const MediaMentionComponent = lazy(
  () => import('./components/mediaMentions/mediaMentions.component')
);
const MediaMentionAddComponent = lazy(
  () => import('./components/mediaMentions/mediaMentionsAdd.component')
);
const MediaMentionEditComponent = lazy(
  () => import('./components/mediaMentions/mediaMentionsEdit.component')
);
const MrssListComponent = lazy(() => import('./components/mrss/mrssList.component'));
const MrssFormComponent = lazy(() => import('./components/mrss/mrssForm.component'));
const MrssMediaFormComponent = lazy(() => import('./components/mrss/mrssMediaForm.component'));
const MrssMediaCreateBulkComponent = lazy(
  () => import('./components/mrss/mrssMediaCreateBulk.component')
);
const MrssMediaFormComponentCopy = lazy(
  () => import('./components/mrss/mrssMediaFormCopy.component')
);
const MrssCategoryFormComponent = lazy(
  () => import('./components/mrss/mrssCategoryForm.component')
);
const MrssEpisodesFormComponent = lazy(
  () => import('./components/mrss/mrssEpisodesForm.component')
);
const ReportSiteInfoComponent = lazy(() => import('./components/reports/siteInfo.component'));
const ReportNewContributorComponent = lazy(
  () => import('./components/reports/newContributor.component')
);
const ReportHeavilyCommentComponent = lazy(
  () => import('./components/reports/heavilyCommentMedia.component')
);
const ReportContributorComponent = lazy(() => import('./components/reports/contributor.component'));
const ReportMissingContributorComponent = lazy(
  () => import('./components/reports/missingContributor.component')
);
const ReportMrssComponent = lazy(() => import('./components/reports/mrssFeed.component'));
const ReportMrssLibraryComponent = lazy(
  () => import('./components/reports/mrss-library.component')
);
const ReportMrssSeriesComponent = lazy(() => import('./components/reports/mrss-series.component'));
const ReportMediaSocialShareComponent = lazy(
  () => import('./components/reports/socialShare.component')
);
const ReportUploadsComponent = lazy(() => import('./components/reports/uploads.component'));
const TopContributorComponent = lazy(
  () => import('./components/topContributor/topContributor.component')
);
const TVListComponent = lazy(() => import('./components/_tv/tvList.component'));
const TVFeatureComponent = lazy(() => import('./components/_tv/feature/tvFeature.component'));
const TVFeatureAddComponent = lazy(() => import('./components/_tv/feature/tvFeatureAdd.component'));
const TVFeatureEditComponent = lazy(
  () => import('./components/_tv/feature/tvFeatureEdit.component')
);
const MessageNotificationComponent = lazy(
  () => import('./components/message/notification.component')
);
const MessageNotificationListComponent = lazy(
  () => import('./components/message/notificationList.component')
);
const BulkVideoDownloadComponent = lazy(
  () => import('./components/bulk-video-download/bulk-video-download.component')
);

// react lazy loading component END
const App = () => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  return (
    <Router>
      <ThemeProvider theme={theme(prefersDarkMode)}>
        <DrawerContainer />
      </ThemeProvider>
    </Router>
  );
};

const theme = (preference: any) =>
  createMuiTheme({
    palette: {
      type: preference ? 'dark' : 'light',
      primary: {
        main: '#0ab7ff',
        dark: '#303030',
      },
      secondary: {
        main: '#ff1744',
        dark: '#303030',
      },
    },
    overrides: {
      MuiButton: {
        sizeSmall: {
          padding: '2px 8px',
        },
      },
      MuiTypography: {
        button: {
          fontSize: '0.8125rem',
        },
        body2: {
          lineHeight: 0, //fix datepicker lineheight issue
        },
      },
    },
  });

// APP CONTAINER DRAWER
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& .MuiAppBar-root, & .MuiDrawer-root': {
      '@media print': {
        display: 'none',
      },
    },
    '-ms-overflow-style': 'none',
    '&::-webkit-scrollbar': {
      '-ms-overflow-style': 'none',
      display: 'none',
      width: 0,
      height: 0,
    },
    '& > *': {
      '& ::-webkit-scrollbar': {
        display: 'none',
        width: 0,
        height: 0,
      },
      '-ms-overflow-style': 'none',
    },
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(1),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  contentGrow: {
    flexGrow: 1,
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  fullWidth: {
    width: '100%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

const DrawerContainer = () => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const isAuthenticate = useSelector((state: any) => state.identity.isAuthenticate);
  const identity = useSelector((state: any) => state.identity.data);

  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  useEffect(() => {
    dispatch(checkIdentity());
  }, [dispatch]);

  const handleLogout = () => {
    localStorage.removeItem('id_token');
    dispatch({
      type: LOGOUT_TYPE,
    });
  };

  if (!isAuthenticate) {
    return <LoginComponent />;
  }

  // ---------- SUB DASHBOARD ----------
  const VISIBLE_FEATURE = APP_FEATURES(identity);
  // TODO FIX THIS TO NOT FILTER ONCE ALL STUFF ARE ADDED
  // const accessControl = APP_FEATURES.filter(feature => feature.name === 'Access Control')[0];
  // const ads = APP_FEATURES.filter(feature => feature.name === 'Ads')[0];
  // // const collection-videos = APP_FEATURES[6];
  // const contests = APP_FEATURES.filter(feature => feature.name === 'Contests')[0];
  // const featureBox = APP_FEATURES.filter(feature => feature.name === 'Feature Box')[0];
  // const photo = APP_FEATURES.filter(feature => feature.name === 'Photo')[0];
  const reports = VISIBLE_FEATURE.filter((feature) => feature.name === 'Reports')[0];
  const message = VISIBLE_FEATURE.filter((feature) => feature.name === 'Message')[0];
  const rss = VISIBLE_FEATURE.filter((feature) => feature.name === 'RSS')[0];
  const bulk = VISIBLE_FEATURE.filter((feature) => feature.name === 'Bulk')[0];
  // ---------- SUB DASHBOARD END ----------

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position='fixed'
        className={clsx(
          classes.appBar,
          {
            [classes.appBarShift]: open,
          },
          classes.spaceBetween
        )}
        color='inherit'
      >
        <Toolbar>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            onClick={handleDrawerOpen}
            edge='start'
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <div className={clsx(classes.fullWidth, classes.header)}>
            <BreadcrumbsComponent />
            <Button
              variant='outlined'
              color='primary'
              endIcon={<ExitToAppIcon />}
              onClick={handleLogout}
            >
              Logout
            </Button>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant='persistent'
        anchor='left'
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerOpen}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        <Divider />
        <DrawerListComponent handleDrawerOpen={handleDrawerOpen} feature={VISIBLE_FEATURE} />
      </Drawer>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        <LoaderBackDrop />
        <SnackBarComponent />
        <ComfirmationComponent />
        <div className={classes.drawerHeader} />
        <Suspense
          fallback={
            <Backdrop className={classes.backdrop} open={true}>
              <CircularProgress color='primary' />
            </Backdrop>
          }
        >
          <Switch>
            <Route path='/tv' exact>
              <TVListComponent />
            </Route>
            <Route path='/tv/feature' exact>
              <TVFeatureComponent />
            </Route>
            <Route path='/tv/feature/add' exact>
              <TVFeatureAddComponent />
            </Route>
            <Route path='/tv/feature/edit/:id' exact>
              <TVFeatureEditComponent />
            </Route>
            <ProtectedRoute
              path='/access-control'
              exact
              permissions='root'
              component={<AccessControlComponent />}
            />
            <ProtectedRoute
              path='/access-control/edit/:id'
              permissions='root'
              component={<AccessControlUserFormComponent />}
            />
            <ProtectedRoute
              path='/access-control/add'
              exact
              permissions='root'
              component={<AccessControlUserFormComponent />}
            />
            <ProtectedRoute
              path='/access-control-group'
              exact
              permissions='root'
              component={<AccessControlComponent />}
            />
            <ProtectedRoute
              path='/access-control-group/edit/:id'
              permissions='root'
              component={<AccessControlGroupFormComponent />}
            />
            <ProtectedRoute
              path='/access-control-group/add'
              exact
              permissions='root'
              component={<AccessControlGroupFormComponent />}
            />
            <ProtectedRoute
              path='/access-control-permission'
              exact
              permissions='root'
              component={<AccessControlComponent />}
            />
            <ProtectedRoute
              path='/access-control-permission/edit/:id'
              permissions='root'
              component={<AccessControlPermissionFormComponent />}
            />
            <ProtectedRoute
              path='/access-control-permission/add'
              exact
              permissions='root'
              component={<AccessControlPermissionFormComponent />}
            />
            <Route path='/reports/AirVuz-MRSS' exact>
              <AirVuzMrssReportComponent />
            </Route>

            <Route path='/reports/AirVuz-MRSS/result' exact>
              <AirVuzMrssReportResultComponent />
            </Route>
            <ProtectedRoute
              path='/autoviews'
              exact
              permissions={['root', 'autoviews-create']}
              component={<AutoViewListComponent />}
            />
            <ProtectedRoute
              path='/autoviews/add'
              exact
              permissions={['root', 'autoviews-create']}
              component={<AutoViewAddFormComponent />}
            />
            <ProtectedRoute
              path='/autoviews/edit/:id'
              exact
              permissions={['root', 'autoviews-create']}
              component={<AutoViewEditFormComponent />}
            />
            <Route path='/badges' exact>
              <BadgeListComponent />
            </Route>
            <Route path='/badges/add' exact>
              <BadgeFormComponent />
            </Route>
            <Route path='/badges/edit/:id' exact>
              <BadgeFormComponent />
            </Route>
            <Route path='/category' exact>
              <CategoryListComponent />
            </Route>
            <Route path='/category/add' exact>
              <CategoryComponent />
            </Route>
            <Route path='/category/edit/:id' exact>
              <CategoryComponent />
            </Route>
            <Route path='/collection-types' exact>
              <CollectionTypeListComponent />
            </Route>
            <Route path='/collection-types/add' exact>
              <CollectionTypeFormComponent />
            </Route>
            <Route path='/collection-types/edit/:id' exact>
              <CollectionTypeFormComponent />
            </Route>
            <Route path='/collection-photos' exact>
              <CollectionPhotoComponent />
            </Route>
            <Route path='/collection-photos/add' exact>
              <CollectionPhotoAddFormComponent />
            </Route>
            <Route path='/collection-photos/edit/:id' exact>
              <CollectionPhotoEditFormComponent />
            </Route>
            <Route path='/collection-videos' exact>
              <CollectionComponent />
            </Route>
            <Route path='/collection-videos/add' exact>
              <CollectionFormComponent />
            </Route>
            <Route path='/collection-videos/edit/:id/copy' exact>
              <CollectionFormCopyComponent />
            </Route>
            <Route path='/collection-videos/edit/:id' exact>
              <CollectionFormComponent />
            </Route>
            <Route path='/comment-media/:id?' exact>
              <CommentComponent />
            </Route>
            <Route path='/comment-user/:id?' exact>
              <CommentComponent />
            </Route>
            <Route path='/contest' exact>
              <ContestComponent />
            </Route>
            <Route path='/contest/add' exact>
              <ContestFormComponent />
            </Route>
            <Route path='/contest/view/:id' exact>
              <ContestFormComponent />
            </Route>
            <Route path='/contest-type' exact>
              <ContestComponent />
            </Route>
            <Route path='/contest-type/add' exact>
              <ContestTypeFormComponent />
            </Route>
            <Route path='/contest-type/edit/:id' exact>
              <ContestTypeFormComponent />
            </Route>
            <Route path='/feature-box' exact>
              <FeatureBoxListComponent />
            </Route>
            <Route path='/feature-box/edit/:id' exact>
              <FeatureBoxFormComponent />
            </Route>
            <Route path='/feature-box/add' exact>
              <FeatureBoxFormComponent />
            </Route>
            <Route path='/feature-box-location' exact>
              <FeatureBoxListComponent />
            </Route>
            <Route path='/feature-box-location/edit/:id' exact>
              <FeatureBoxLocationForm />
            </Route>
            <Route path='/feature-box-location/add' exact>
              <FeatureBoxLocationForm />
            </Route>
            <Route path='/history/:id?' exact>
              <HistoryComponent />
            </Route>
            <Route path='/media-mentions' exact>
              <MediaMentionComponent />
            </Route>
            <Route path='/media-mentions/add' exact>
              <MediaMentionAddComponent />
            </Route>
            <Route path='/media-mentions/edit/:id' exact>
              <MediaMentionEditComponent />
            </Route>
            <Route path='/rss/mrss' exact>
              <MrssListComponent />
            </Route>
            <Route path='/rss/mrss/add' exact>
              <MrssFormComponent />
            </Route>
            <Route path='/rss/mrss/edit/:id' exact>
              <MrssFormComponent />
            </Route>
            <Route path='/rss/mrss-media' exact>
              <MrssListComponent />
            </Route>
            <Route path='/rss/mrss-media/edit/:id/copy' exact>
              <MrssMediaFormComponentCopy />
            </Route>
            <Route path='/rss/mrss-media/edit/:id' exact>
              <MrssMediaFormComponent />
            </Route>
            <Route path='/rss/mrss-media/add' exact>
              <MrssMediaFormComponent />
            </Route>
            <Route path='/rss/mrss-media/create-bulk' exact>
              <MrssMediaCreateBulkComponent />
            </Route>
            <Route path='/rss/mrss-category' exact>
              <MrssListComponent />
            </Route>
            <Route path='/rss/mrss-category/edit/:id' exact>
              <MrssCategoryFormComponent />
            </Route>
            <Route path='/rss/mrss-category/add' exact>
              <MrssCategoryFormComponent />
            </Route>
            <Route path='/rss/mrss-episodes' exact>
              <MrssListComponent />
            </Route>
            <Route path='/rss/mrss-episodes/edit/:id' exact>
              <MrssEpisodesFormComponent />
            </Route>
            <Route path='/rss/mrss-episodes/add' exact>
              <MrssEpisodesFormComponent />
            </Route>
            <Route path='/rss/mrss-series' exact>
              <MrssListComponent />
            </Route>
            <Route path='/rss/mrss-series/edit/:id' exact>
              <MrssSeriesFormComponent />
            </Route>
            <Route path='/rss/mrss-series/add' exact>
              <MrssSeriesFormComponent />
            </Route>
            <Route path='/partners/exclusive' exact>
              <PartnerExclusiveListComponent />
            </Route>
            <Route path='/partners/exclusive/add' exact>
              <PartnerExclusiveAddComponent />
            </Route>
            {/* <Route path="/partners/exclusive/edit/:id" exact>
              <PartnerExclusiveEditComponent
                hook={usePartnerList}
              />
            </Route> */}
            <Route path='/partners' exact>
              <PartnerListComponent />
            </Route>
            <Route path='/partners/add' exact>
              <PartnerComponent />
            </Route>
            <Route path='/partners/edit/:id' exact>
              <PartnerComponent />
            </Route>
            <Route path='/photo' exact>
              <PhotoListComponent />
            </Route>
            <Route path='/photo/curation/:id' exact>
              <PhotoCurationComponent />
            </Route>
            <Route path='/reports' exact>
              <SubDashboardComponent subFeature={reports} />
            </Route>
            <Route path='/rss' exact>
              <SubDashboardComponent subFeature={rss} />
            </Route>
            <Route path='/bulk' exact>
              <SubDashboardComponent subFeature={bulk} />
            </Route>
            <Route path='/bulk/video-download' exact>
              <BulkVideoDownloadComponent />
            </Route>
            <Route path='/reports/video-feature-eligible'>
              <ReportVideoFeatureComponent />
            </Route>
            <Route path='/reports/video-deleted' exact>
              <ReportVideoDeleteComponent />
            </Route>
            <Route path='/reports/partner' exact>
              <PartnerComponent />
            </Route>
            <Route path='/reports/mrss' exact>
              <ReportMrssComponent />
            </Route>
            <Route path='/reports/mrss-media-library' exact>
              <ReportMrssLibraryComponent />
            </Route>
            <Route path='/reports/mrss-media-series' exact>
              <ReportMrssSeriesComponent />
            </Route>
            <Route path='/reports/uploads' exact>
              <ReportUploadsComponent />
            </Route>
            <Route path='/reports/partner/:id' exact>
              <PartnerComponent />
            </Route>
            <ProtectedRoute
              path='/reports/judge'
              exact
              permissions={['root', 'admin-judge']}
              component={<ReportJudgeCollectionComponent />}
            />
            <Redirect from='/reports/judge/result' to='/reports/judge/selected-result' exact />
            <ProtectedRoute
              path='/reports/judge/selected-result'
              exact
              permissions={['root', 'admin-judge']}
              component={<ReportJudgeResultComponent />}
            />
            <ProtectedRoute
              path='/reports/judge/:id'
              exact
              permissions={['root', 'admin-judge']}
              component={<ReportJudgeResultOneComponent />}
            />
            <ProtectedRoute
              path='/reports/judge/:id/archive'
              exact
              permissions={['root', 'admin-judge']}
              component={<ReportJudgeResultArchive />}
            />

            <ProtectedRoute
              path='/reports/judge/:collectionId/archive/:id'
              exact
              permissions={['root', 'admin-judge']}
              component={<ReportJudgeArchiveInfo />}
            />
            <Route path='/banner' exact>
              <BannerComponent />
            </Route>
            <Route path='/banner-slider' exact>
              <BannerComponent />
            </Route>
            <Route path='/banner-slider/add' exact>
              <BannerSliderFormComponent />
            </Route>
            <Route path='/banner-slider/edit/:id' exact>
              <BannerSliderFormComponent />
            </Route>
            <Route path='/banner/add' exact>
              <BannerFormComponent />
            </Route>
            <Route path='/banner/edit/:id' exact>
              <BannerFormComponent />
            </Route>
            <Route path='/reports/site-info' exact>
              <ReportSiteInfoComponent // TODO
              />
            </Route>
            <Route path='/reports/new-contributor' exact>
              <ReportNewContributorComponent />
            </Route>
            <Route path='/reports/heavily-commented-media' exact>
              <ReportHeavilyCommentComponent />
            </Route>
            <Route path='/reports/missing-contributor' exact>
              <ReportMissingContributorComponent />
            </Route>
            <Route path='/reports/social-media-share' exact>
              <ReportMediaSocialShareComponent />
            </Route>
            <Route path='/reports/contributor' exact>
              <ReportContributorComponent />
            </Route>
            <ProtectedRoute
              path='/top-contributor'
              permissions='root'
              component={<TopContributorComponent />}
            />
            <ProtectedRoute
              exact
              path='/user/add'
              permissions='root'
              component={<UserAddComponent />}
            />
            <Route path='/user/:id'>
              <UserInfoComponent />
            </Route>
            <Route path='/user' exact>
              <UserComponent />
            </Route>
            <Route path='/upload' exact>
              <UploadComponent />
            </Route>
            <Route path='/video' exact>
              <VideoComponent />
            </Route>
            <Route path='/video/curation/:id'>
              <VideoCurationComponent />
            </Route>
            <Route path='/message' exact>
              <SubDashboardComponent subFeature={message} />
            </Route>
            <Route path='/message/notification' exact>
              <MessageNotificationListComponent />
            </Route>
            <Route path='/message/notification/compose' exact>
              <MessageNotificationComponent />
            </Route>
            <Route path='/message/notification/:id' exact>
              <MessageNotificationComponent />
            </Route>
            <Route path='/' exact>
              <DashboardComponent feature={VISIBLE_FEATURE} />
            </Route>
            {/* IF PATH DOES NOT EXIST REDIRECT */}
            <Redirect to='/' />
          </Switch>
        </Suspense>
      </main>
    </div>
  );
};
// -------- END APP CONTAINER DRAWER

export default App;
